import '../../modules/mode-components';

import * as angular from 'angular';

import DatasetService from '../../services/dataset-service';

class TableSidebarController {
  static $inject = ['DatasetService', 'StoreService', '$scope'];

  private selectedTable: {
    view: string;
    queryToken: string;
    token: string;
  };
  private selectedColumn: any;
  private queryToken: string;

  constructor(private datasetService: DatasetService, private store, private $scope: angular.IScope) {
    store.connectPath($scope, 'editor', (next) => {
      this.selectedTable =
        next.viz.type === 'table'
          ? {
              view: next.viz.tableView,
              queryToken: next.viz.queryToken,
              token: next.viz.token,
            }
          : null;

      this.selectedColumn = next.subViz ? next.subViz.selectedTableColumn : null;
    });
  }

  datasetIsAvailable() {
    return (
      this.datasetService.datasets &&
      this.selectedTable &&
      this.datasetService.datasets[this.queryToken] &&
      this.datasetService.datasets[this.queryToken].state !== 'failed' &&
      this.datasetService.datasets[this.queryToken].state !== 'cancelled' &&
      this.datasetService.datasets[this.queryToken].content
    );
  }
}

const tableSidebarComponent: angular.IComponentOptions = {
  bindings: {
    queryToken: '<',
  },
  template: `
<div class="sidebar-content chart-sidebar" ng-if="ctrl.datasetIsAvailable()">
  <table-settings
    ng-if="!ctrl.selectedColumn"
    view="ctrl.selectedTable.view"
    dataset="ctrl.datasetService.datasets[ctrl.queryToken]"
    token="ctrl.selectedTable.token">
  </table-settings>
  <table-column-settings
    ng-if="ctrl.selectedColumn"
    view="ctrl.selectedTable.view"
    token="ctrl.selectedTable.token"
    selected-column="ctrl.selectedColumn">
  </table-column-settings>
</div>
`,
  controller: TableSidebarController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('tableSidebar', tableSidebarComponent);
